import { Slide } from "@jelly/lesson";

import theory from "../../theory";
import config from "appConfig";

import variables from "../../../../../../assets/styles/sass-resources.scss";

const principle: Slide = {
  description:
    "Here we describe stepwise how to design a listening experiment. Such an experiment is usually created in order to check a hypothesis, which is based on an initial observeration. Each step requires decisions of the experiment designer.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [1, 4, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Stimuli corresponding the conditions are generated</b>",
                  formatter: "html",
                  scrollbars: false,
                },
              },
              styles: {
                fontSize: "18px",
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: {
                  variant: "layout",
                  data: {
                    type: "table",
                    options: {
                      cols: 1,
                      rows: 5,
                      components: [
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data:
                                    "The stimuli need to be varied in a controlled way, i.e., in this</br>example, only the level of reverberation time is modified.",
                                  scrollbars: false,
                                  formatter: "html",
                                },
                              },
                              styles: {
                                textAlign: "center",
                                padding: "2% 0 0 0",
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "audioButton",
                                options: {
                                  text: "Low: <b>T<sub>1</sub> = 0.5 s</b>",
                                  icon: "cis-volume-high",
                                  shape: "round",
                                  theme: "primary",
                                  url: `${config.ASSETS_URL}/02/23/principle/principle-1-500ms.wav`,
                                },
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "audioButton",
                                options: {
                                  text: "Low: <b>T<sub>2</sub> = 1.0 s</b>",
                                  icon: "cis-volume-high",
                                  shape: "round",
                                  theme: "primary",
                                  url: `${config.ASSETS_URL}/02/23/principle/principle-1-1000ms.wav`,
                                },
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "audioButton",
                                options: {
                                  text: "Low: <b>T<sub>3</sub> = 1.5 s</b>",
                                  icon: "cis-volume-high",
                                  shape: "round",
                                  theme: "primary",
                                  url: `${config.ASSETS_URL}/02/23/principle/principle-1-1500ms.wav`,
                                },
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data:
                                    "In this example, the stimuli were generated using</br>an acoustical simulation software, where the</br>reverberation time can accurately be controlled.",
                                  scrollbars: false,
                                  formatter: "html",
                                },
                              },
                              styles: {
                                textAlign: "center",
                                padding: "0 0 2% 0",
                              },
                            },
                          },
                        ],
                      ],
                    },
                    styles: {
                      border: `1px solid ${variables["primary"]}`,
                      borderRadius: "10px",
                    },
                  },
                },
              },
              styles: {
                padding: "0 25%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "Here only one distance of d=6 m was chosen. In a real experiment, the distance perception would be investigated for more than one distance, e.g., for distances between 1 and 10 m. This would be another independent variable, leading to more test conditions of the experiment (distance X room). Only if the acoustical simulation is validated, it is eligible tool to apply it in an experiment about human auditory distance perception.",
                  size: "large-thin",
                  color: "primary",
                  direction: "row",
                },
              },
              styles: {
                padding: "1% 0 2% 0",
                maxWidth: "70%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
